import { Modal, Spinner, Typography } from '@automata/ui';
import { ValidateWorkflowError } from '@automata/wfb-api';
import { WorkflowValidationResult } from '@automata/wfb-api/src/apis/wfbApiSchemas';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import { Stack } from '@mui/system';

export type ValidateWorkflowModalProps = {
  open: boolean;
  onClose: () => void;
  validationResult: WorkflowValidationResult | null;
  status: 'loading' | 'error' | 'success' | 'idle';
  error: ValidateWorkflowError | null;
};

export const ValidateWorkflowModal = ({
  open,
  onClose,
  validationResult,
  error,
  status,
}: ValidateWorkflowModalProps): JSX.Element => (
  <Modal
    open={open}
    onClose={onClose}
    title={
      validationResult && status === 'success'
        ? `Validation Result: ${
            validationResult.is_valid ? 'VALID' : 'INVALID'
          }`
        : 'Validation Result'
    }
  >
    <>
      {status === 'loading' && <Spinner />}
      {status === 'error' && <>{error?.toString()}</>}
      {status === 'success' && validationResult && (
        <Stack gap={2}>
          <Stack gap={1}>
            <Typography variant="h6">Errors</Typography>
            {validationResult.errors.length === 0 ? 'None' : ''}
            {validationResult.errors.map((error, index) => (
              <Accordion key={index} disableGutters>
                <AccordionSummary key={index} sx={{ px: 0 }}>
                  {error.msg}
                </AccordionSummary>
                <AccordionDetails>
                  <pre key={index}>{JSON.stringify(error, null, 2)}</pre>
                </AccordionDetails>
              </Accordion>
            ))}
          </Stack>

          <Stack gap={1}>
            <Typography variant="h6">Warnings</Typography>
            {validationResult.warnings.length === 0 ? 'None' : ''}
            {validationResult.warnings.map((warning, index) => (
              <Accordion key={index} disableGutters>
                <AccordionSummary key={index} sx={{ px: 0 }}>
                  {warning.msg}
                </AccordionSummary>
                <AccordionDetails>
                  <pre key={index}>{JSON.stringify(warning, null, 2)}</pre>
                </AccordionDetails>
              </Accordion>
            ))}
          </Stack>
        </Stack>
      )}
    </>
  </Modal>
);
